import { __assign } from 'tslib';
import * as React from 'react';
import { UitkIcon } from 'uitk-react-icons';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-avatar.css';
import UitkAvatarGroupContext from './uitk-avatar-group.esm.js';

var getClassNameList = classNames.bind(styles);
var UitkAvatar = function (props) {
    var _a, _b;
    var border = props.border, size = props.size, image = props.image, text = props.text, icon = props.icon, className = props.className;
    var baseCssClass = 'uitk-avatar';
    var avatarClassNames = getClassNameList(baseCssClass, (_a = {},
        _a["".concat(baseCssClass, "-").concat(size)] = size,
        _a), (_b = {},
        _b["".concat(baseCssClass, "-hasborder")] = border,
        _b), className);
    var renderContent = function () {
        if (image) {
            return (React.createElement("img", { className: getClassNameList(avatarClassNames, "".concat(baseCssClass, "-image")), src: image.src, alt: image.alt }));
        }
        if (text) {
            return (React.createElement("div", { className: getClassNameList(avatarClassNames, "".concat(baseCssClass, "-text"), "".concat(baseCssClass, "-text-").concat(size)) }, text));
        }
        if (icon) {
            return (React.createElement("div", { className: getClassNameList(avatarClassNames, "".concat(baseCssClass, "-icon"), "".concat(baseCssClass, "-icon-").concat(size)) },
                React.createElement(UitkIcon, { name: icon })));
        }
        return React.createElement("div", { className: getClassNameList(avatarClassNames, "".concat(baseCssClass, "-placeholder")) });
    };
    return renderContent();
};
var withSizeAndBorder = function (Component) {
    // eslint-disable-next-line react/display-name
    return function (props) {
        return (React.createElement(UitkAvatarGroupContext.Consumer, null, function (_a) {
            var size = _a.size, border = _a.border;
            return React.createElement(Component, __assign({}, props, { size: size, border: border }));
        }));
    };
};
var UitkAvatarGroupItem = function (props) {
    var AvatarSized = withSizeAndBorder(UitkAvatar);
    return (React.createElement("li", { className: getClassNameList("uitk-avatar-group-item") },
        React.createElement(AvatarSized, __assign({}, props))));
};
UitkAvatar.defaultProps = {
    size: 'medium',
    border: false
};
UitkAvatar.displayName = 'UitkAvatar';

export { UitkAvatar, UitkAvatarGroupItem };
